import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-background-50 px-4 text-center">
      <div className="pointer-events-none absolute -top-24 right-0 h-80 w-80 rounded-full bg-primary-500/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 left-0 h-80 w-80 rounded-full bg-accent-500/15 blur-3xl" />
      <div className="relative z-10">
        <p className="font-heading text-7xl text-gradient-warm md:text-9xl">404</p>
        <h1 className="mt-4 font-heading text-xl text-foreground-950 md:text-2xl">这个页面迷路了</h1>
        <p className="mt-2 text-sm text-foreground-600">没有找到你访问的页面：{location.pathname}</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-gradient-to-r from-primary-500 to-primary-600 px-6 py-2.5 text-sm font-bold text-background-50 transition-opacity hover:opacity-90"
        >
          <i className="ri-home-4-line" /> 返回首页
        </Link>
      </div>
    </div>
  );
}